
<template>
  <div>

    <index-card fluid>
      <template slot="header">
        <v-row>
          <v-col class="white--text d-flex justify-space-between headline">
            <div class="d-flex align-center">
              <v-btn icon color="blue-grey darken-1" :to="{name: 'Home'}"><v-icon color="white">mdi-arrow-left</v-icon></v-btn>
            </div>
            <div>
              <span>Extratos</span>
            </div>
            <div>
              <v-icon color="white" @click="reloadData" style="cursor: pointer">mdi-refresh</v-icon>
              <v-dialog v-model="day_dialog" persistent width="290px">
                <template v-slot:activator="{ on }">
                  <v-chip color='white' v-on="on">
                    {{ $moment(day_selected).format('DD/MM/YYYY') }}
                  </v-chip>
                </template>
                <v-date-picker v-model="day_selected_aux" color="blue-grey darken-4" locale="pt-br" scrollable
                  close-on-content-click>
                  <v-spacer></v-spacer>
                  <v-btn text color="green" @click="saveDate">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </div>
          </v-col>
        </v-row>
      </template>
      <template slot="data_table">
        <v-card>
          <v-card-text class="py-0 px-0">
            
            <v-tabs v-model="tab" color="white" slider-color="primary" light grow icons-and-text flat>
              <v-tab ripple :class="tab == 0 ? 'primary--text' : ''">
                Boletos
                <v-icon :large="tab == 0" :color="tab == 0 ? 'primary' : ''">{{ 'mdi-barcode'}}</v-icon>
              </v-tab>
              <v-tab ripple :class="tab == 1 ? 'primary--text' : ''">
                Cheques
                <v-icon :large="tab == 1" :color="tab == 1 ? 'primary' : ''">{{ 'mdi-checkbook'}}</v-icon>
              </v-tab>
              <v-tab ripple :class="tab == 2 ? 'primary--text' : ''">
                PIX
                <v-icon :large="tab == 2" :color="tab == 2 ? 'primary' : ''">{{ 'mdi-qrcode'}}</v-icon>
              </v-tab>
              <v-tabs-items v-model="tab" touchless>

                <v-tab-item :value="0">
                  <div>
                    <bill-extract ref="billExtract" v-if="tab == 0" :day_selected="day_selected"></bill-extract>
                  </div>
                </v-tab-item>
                <v-tab-item :value="1">
                  <div>
                    <check-extract ref="checkExtract" v-if="tab == 1" :day_selected="day_selected"></check-extract>
                  </div>
                </v-tab-item>
                <v-tab-item :value="2">
                  <div>
                    <pix-extract ref="pixExtract" v-if="tab == 2" :day_selected="day_selected"></pix-extract>
                  </div>
                </v-tab-item>

              </v-tabs-items>
            </v-tabs>

          </v-card-text>
        </v-card>
      </template>
    </index-card>
    

  </div>
</template>

<script>
import BillExtract from './shared/BillExtract.vue'
import CheckExtract from './shared/CheckExtract.vue'
import PixExtract from './shared/PixExtract.vue'

export default {
  components: { BillExtract, PixExtract, CheckExtract,
    IndexCard: () => import("@/_backoffice/_registrations/components/shared/index/IndexCard.vue"),
   },
  name: 'ListExtracts',
  data() {
    return {
      ready: false,
      tab: 4,
      day_selected: this.$moment().format('YYYY-MM-DD'),
      day_selected_aux: this.$moment().format('YYYY-MM-DD'),
      day_dialog: false,
    }
  },
  methods: {
    reloadData(){
      if(this.tab === 0 && this.$refs.billExtract && this.$refs.billExtract.getExtract){
        this.$refs.billExtract.getExtract('bill')
      } else if(this.tab === 1 && this.$refs.checkExtract && this.$refs.checkExtract.getExtract){
        this.$refs.checkExtract.getExtract('check')
      } else if(this.tab === 2 && this.$refs.pixExtract && this.$refs.pixExtract.getExtract){
        this.$refs.pixExtract.getExtract('pix')
      }
    },
    saveDate(){
      this.day_selected = this.day_selected_aux
      this.day_dialog = false
    },
  },
}
</script>